//密码长度验证
export const passwordlength_rules = (rule, value, callback) => {
  if (value.length < 6) callback(new Error("密码不能少于6位"));
  else callback();
};

//手机号格式验证
export const phone_rules = (rule, value, callback) => {
  if (value) {
    let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
    if (value && !reg.test(value)) {
      return callback(new Error("手机号格式不正确"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};

//邮箱格式验证
export const email_rules = (rule, value, callback) => {
  if (value) {
    var reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/;
    if (!reg.test(value)) {
      return callback(new Error("邮箱格式不正确"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};

//网址格式验证
export const url_rules = (rule, value, callback) => {
  var reg = /(http|https):\/\/[^s]*/;
  if (!reg.test(value)) {
    return callback(new Error("网址格式不正确"));
  } else {
    callback();
  }
};

//身份证号格式验证
export const idcard_rules = (rule, value, callback) => {
  if (value) {
    var reg =
      /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])\d{3}(\d|X|x)$/;
    if (!reg.test(value)) {
      return callback(new Error("身份证号格式不正确"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
